import { TRIVIA_CATEGORY_KEYS } from "@/lib/trivia/catalog";
import type { TriviaMatchState } from "@/lib/trivia/matchTypes";

export function buildDebugFinishedTriviaState(
  base: TriviaMatchState,
  userId: string,
  outcome: "win" | "lose",
): TriviaMatchState {
  const rival = base.playerIds.find((p) => p !== userId) ?? null;
  if (!rival) {
    throw new Error("debug-finish requires two players");
  }
  const state = structuredClone(base) as TriviaMatchState;
  delete state.answerRound;
  state.phase = "spin";
  state.activeCategory = null;
  state.activeQuestionId = null;
  state.spinSegmentIndex = null;
  state.lastResult = null;
  const allKeys = [...TRIVIA_CATEGORY_KEYS];
  const partialKeys = allKeys.slice(0, 3);
  if (outcome === "win") {
    state.wedges[userId] = [...allKeys];
    state.wedges[rival] = [...partialKeys];
    state.scores[userId] = 100;
    state.scores[rival] = 30;
  } else {
    state.wedges[rival] = [...allKeys];
    state.wedges[userId] = [...partialKeys];
    state.scores[rival] = 100;
    state.scores[userId] = 30;
  }
  return state;
}
